import React from "react";
import { useTranslation } from "react-i18next";
import OneContact from "./OneContact";
import Icon from "@mdi/react";
import {
  mdiPhone,
  mdiEmail,
  mdiMapMarker,
  mdiWeb,
  mdiStorefront,
  mdiCashMultiple,
} from "@mdi/js";

export default function AllContacts() {
  const { t } = useTranslation();

  const IconTemplate = (path) => (
    <div className="bg-vinefin-100 p-3 rounded-full text-vinefin-700 group-hover:bg-vinefin-700 group-hover:text-white transition-colors duration-300">
      <Icon path={path} size={1.2} />
    </div>
  );

  return (
    <div className="bg-gray-50 px-6 md:px-12 py-16 border-t border-gray-200">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-vinefin-900 mb-12 text-center">
          {t("contact.title")}
        </h1>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <OneContact
            name={t("contact.phone")}
            content={["+420 775 072 622", "+420 730 180 084"]}
            icon={IconTemplate(mdiPhone)}
          />
          <OneContact
            name={t("contact.address")}
            content={["ČSA 27/1, 785 01 Šternberk, Česká republika"]}
            icon={IconTemplate(mdiMapMarker)}
          />
          <OneContact
            name={t("contact.bank")}
            content={["Česká spořitelna a.s., 5595351389/0800"]}
            icon={IconTemplate(mdiCashMultiple)}
          />
          <OneContact
            name={t("contact.email")}
            content={["info@vinefin.cz"]}
            icon={IconTemplate(mdiEmail)}
          />
          <OneContact
            name={t("contact.id")}
            content={["07903936"]}
            icon={IconTemplate(mdiStorefront)}
          />
          <OneContact
            name={t("contact.website")}
            content={["vinefin.cz"]}
            icon={IconTemplate(mdiWeb)}
          />
        </div>
      </div>
    </div>
  );
}
